<!-- Filter - Search - Form  -->
<div *ngIf="userPermissions?.invoicing_list?.view" class="data-action-form">
  <div class="row justify-content-between align-items-end">
    <!-- Filter Fields START -->
    <div class="col-12 col-lg-7">
      <div class="row mx-n2 align-items-end">
        <div class="col-12 col-sm-6 col-md px-2">
          <div class="form-group">
            <label>Project Assistant</label>
            <select
              class="form-control select2"
              #projectAssistant
              id="assistant_id"
              [(ngModel)]="searchInfo.assistant_id"
              name="assistant_id"
              (change)="searchInTable(projectAssistant.value, 'assistant_id')"
              [disabled]="disableAssistantSelect">
              <option selected="selected" value="">Assistant</option>
              <option *ngFor="let item of ProjectAssistantData" value="{{ item.id }}">
                {{
                  item.employee_alias != null && item.employee_alias != '' && item.employee_alias != undefined
                    ? item.employee_alias
                    : item.first_name + ' ' + item.last_name
                }}
              </option>
            </select>
            <div class="hiddenInput">
              <input
                type="text"
                [(ngModel)]="searchInfo.assistant_id"
                (blur)="searchInTable(projectAssistant.value, 'assistant_id')" />
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md px-2">
          <div class="form-group">
            <label>Project Manager</label>
            <select
              class="form-control select2"
              #project_manager_id
              id="project_manager_id"
              [(ngModel)]="searchInfo.project_manager_id"
              name="project_manager_id"
              (change)="searchInTable(project_manager_id.value, 'project_manager_id')">
              <option selected="selected" value="">Project Manager</option>
              <option *ngFor="let item of projectManagerData" value="{{ item.id }}">
                {{ item.employee_alias ? item.employee_alias : item.first_name + ' ' + item.last_name }}
              </option>
            </select>
            <div class="hiddenInput">
              <input
                type="text"
                [(ngModel)]="searchInfo.project_manager_id"
                (blur)="searchInTable(project_manager_id.value, 'project_manager_id')" />
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md px-2">
          <div class="form-group">
            <label>Invoice Status</label>
            <select
              class="form-control select2MultipleWithCheck"
              #invoice_status
              id="invoice_status"
              (change)="searchInTable(invoice_status.value, 'invoice_status')"
              name="invoice_status"
              data-placeholder="Invoice Status"
              multiple="multiple">
              <option
                *ngFor="let item of invoiceStatusData"
                value="{{ item.id }}"
                [selected]="checkIsSelected(item.id, 'invoice_status')">
                {{ item.name }}
              </option>
            </select>
            <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
              <input
                type="text"
                class="invoice_status multiCheckVal"
                [(ngModel)]="searchInfo.invoice_status"
                #invoice_status1
                (blur)="searchInTable(invoice_status1.value, 'invoice_status')" />
            </div>
          </div>
        </div>
        <div class="col-12 col-md-auto px-2">
          <div class="form-group">
            <a href="javascript:;" data-toggle="modal" data-target="#filter" class="btn btn-outline-primary more-filter"
              >More Filters <span class="dot">.</span> 4</a
            >
          </div>
        </div>
      </div>
    </div>
    <!-- Filter Fields END -->

    <!-- Search Fields START -->
    <div class="col-12 col-lg-5 col-xl-4">
      <div class="row mx-n2 align-items-end">
        <!-- Reset Button -->
        <div *ngIf="userPermissions?.invoicing_reset?.edit" class="col-auto px-2">
          <a
            href="#"
            class="text-blue invoices-reset-button"
            data-toggle="modal"
            data-target="#reset-confirmation-modal">
            Reset
          </a>
        </div>
        <!-- Search Field -->
        <div class="col px-2">
          <div class="search-box">
            <div class="form-group">
              <input
                type="text"
                name=""
                placeholder="Search"
                class="form-control fild"
                [(ngModel)]="searchInfo.search"
                #search
                (keyup.enter)="searchInTable(search.value, 'search')" />
              <button type="submit" class="search"><i class="fas fa-search"></i></button>
            </div>
          </div>
        </div>
        <!-- Export Button -->
        <div *ngIf="userPermissions?.invoicing_list?.edit" class="col-12 col-sm-3 col-md-4 px-2">
          <div class="form-group">
            <a
              href="#"
              data-toggle="modal"
              data-target="#create-job"
              class="btn btn-block btn-primary"
              (click)="generateCSV(); (false)">
              Export
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- Search Fields END -->
  </div>
</div>
<!-- Filter - Search - Form  End-->

<!-- Filter Actions (Save | Clear) START-->
<div *ngIf="userPermissions?.invoicing_list?.view" class="filter-options d-flex justify-content-between">
  <ul class="list-unstyled d-flex">
    <li><a href="javascript:;" (click)="saveFilter()">Save Filters</a></li>
    <li class="divider">|</li>
    <li><a href="javascript:;" (click)="clearFilter()">Clear Filters</a></li>
  </ul>
  Job Count: {{ jobsData.length }}
</div>
<!-- Filter Actions (Save | Clear) END-->

<!-- DataTable Section START -->
<div *ngIf="userPermissions?.invoicing_list?.view" class="invoices-table">
  <div class="table-responsive">
    <table class="table jobs-invoice-data-table" id="invoiceTable"></table>
  </div>
</div>
<!-- DataTable Section END -->

<div class="hiddenInput">
  <input
    type="text"
    value=""
    class="newInvoiceCustomerSortData"
    #newInvoiceData
    (blur)="sortInvoiceCustomerData(newInvoiceData.value)" />
</div>

<div class="hiddenButton">
  <button (click)="loadMoreData()" class="invoiceLoadMoreData"></button>
</div>

<!-- More Filters Modal -->
<div class="modal fade" id="filter" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content pb-0">
      <form action="#" id="FiltersForm" name="filter_form" #filter_form>
        <div class="modal-header">
          <h5 class="modal-title">More Filters</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"><i class="fal fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>Job Status</label>
            <select
              class="form-control select2MultipleWithCheck"
              #status1
              data-placeholder="Job Status"
              name="status"
              multiple="multiple"
              id="status">
              <option
                *ngFor="let item of jobStatus"
                value="{{ item.value }}"
                [selected]="checkIsSelected(item.value, 'status')">
                {{ item.name }}
              </option>
            </select>
            <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
              <input
                type="text"
                class="status multiCheckVal"
                name="searchInfo_status"
                [(ngModel)]="searchInfo.status"
                #status />
            </div>
          </div>
          <div class="form-group">
            <label>Department</label>
            <select
              class="form-control select2MultipleWithCheck"
              id="department_codes"
              name="department_codes"
              data-placeholder="Department"
              multiple="multiple">
              <option
                [selected]="checkIsSelected(item.department_short_code, 'department_codes')"
                *ngFor="let item of departmentsData"
                value="{{ item.department_short_code }}">
                {{ item.department_short_code + ' | ' + item.department_name }}
              </option>
            </select>
            <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
              <input
                type="text"
                [(ngModel)]="searchInfo.department_codes"
                class="multiCheckVal"
                #departmentCodes
                name="dept_codes" />
            </div>
          </div>
          <div class="form-group">
            <label>Owners</label>
            <select
              class="form-control select2"
              #ownerId
              [(ngModel)]="searchInfo.owner_id"
              name="owner_id"
              id="ownerId">
              <option value="" selected="selected">Owners</option>
              <option *ngFor="let item of ownersData" value="{{ item.id }}">{{ item.owner_name }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Customer</label>
            <select
              class="form-control select2"
              #arCustomer
              [(ngModel)]="searchInfo.contact_ar_customer_name_id"
              name="contact_ar_customer_name_id"
              id="arCustomer">
              <option value="" selected="selected">Customer</option>
              <option *ngFor="let item of arCustomerData" value="{{ item.id }}">
                {{ item.customer_id + ' | ' + item.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="modal-footer justify-content-center border-0">
          <button type="button" class="btn btn-outline-primary width-fix" data-dismiss="modal" #closeFilterModel>
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary width-fix"
            (click)="
              searchInTable(
                arCustomer.value,
                'contact_ar_customer_name_id',
                status.value,
                'status',
                departmentCodes.value,
                'department_codes',
                ownerId.value,
                'owner_id'
              )
            ">
            Apply Filters
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- More Filters Modal End-->

<app-pdf-generate #messagesPdf></app-pdf-generate>
<div>
  <app-chat-modal
    #chatModal
    [job]="jobDetail"
    [commentType]="commentType"
    (printComments)="updateMessagesPdf($event)"></app-chat-modal>
</div>

<reset-confirmation-modal
  *ngIf="userPermissions?.invoicing_reset?.edit"
  (resetInvoices)="resetInvoices()"></reset-confirmation-modal>
